import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const PlatformSettingsContext = createContext({});

export function PlatformSettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    enable_promotions: true,
    enable_reviews: true,
    enable_chat: true,
    require_ghana_card: true,
    min_booking_notice_hours: 24,
    max_booking_advance_days: 30,
  });

  useEffect(() => {
    axios.get(`${API}/api/platform/settings`)
      .then(res => setSettings(prev => ({ ...prev, ...res.data })))
      .catch(() => {});
  }, []);

  return (
    <PlatformSettingsContext.Provider value={settings}>
      {children}
    </PlatformSettingsContext.Provider>
  );
}

export const usePlatformSettings = () => useContext(PlatformSettingsContext);
